import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Header, Title, TopBar } from "@/components";
import { TopBarItem } from "@/components/TopBar/types";

import logOutIcon from "@assets/icons/logOut.svg";

import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

import { useAppDispatch } from "@/redux/store";
import { fetchGetCards } from "@/redux/profile/cards/asyncActions";
import { fetchHistory } from "@/redux/profile/history/asyncActions";
import { fetchProfileInfo } from "@/redux/profile/settings/getProfileInfo/asyncActions";
import { resetCardsState } from "@/redux/profile/cards/slice";

import { ProfilePropsType } from "./types";
import { ProfileMainScreen } from "./components/ProfileMainScreen/ProfileMainScreen";
import styles from "./Profile.module.scss";

export const ProfileLayout: React.FC<ProfilePropsType> = ({ title }) => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const windowWidth = useCurrentWidth();
	const breakPoint = MediaBreakPoints.MOBILE_LARGE;

	const topBarItems: TopBarItem[] = [
		{ id: "history", text: "История покупок", path: "history" },
		{ id: "cards", text: "Привязанные карты", path: "cards" },
		{ id: "settings", text: "Настройки профиля", path: "settings" },
		{ id: "logout", text: "Выйти из аккаунта", img: logOutIcon, path: "logout" },
	];

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	const handleItemClick = (item: TopBarItem) => {
		if (item.id === "history") {
			dispatch(fetchHistory());
		} else if (item.id === "cards") {
			dispatch(fetchGetCards());
		} else if (item.id === "settings") {
			dispatch(fetchProfileInfo());
		}
	};

	useEffect(() => {
		return () => {
			dispatch(resetCardsState());
		};
	}, [dispatch]);

	return (
		<>
			<Header title={title} />
			<main>
				<section className="container">
					<Title>{title}</Title>
					{windowWidth > breakPoint ? (
						<div className={styles.wrapper}>
							<TopBar
								items={topBarItems}
								basePath="/profile"
								onItemClick={handleItemClick}
								breakPoint={breakPoint}
							/>
							<div className={styles.content}>
								<Outlet />
							</div>
						</div>
					) : (
						location.pathname === "/profile" && windowWidth < breakPoint ? (
							<ProfileMainScreen />
						) : (
							<div className={styles.wrapper}>
								<Outlet />
							</div>
						)
					)}
				</section>
			</main>
		</>
	);
};
